import { defaultStartDate, isValidDate } from '@givelify/utils';
import { Dayjs } from 'dayjs';
import { useSelector } from 'react-redux';
import { AppState } from '../store';

export const useDoneeStartDate = (): Dayjs =>
    useSelector((state: AppState) => {
        const date = state?.Donee?.donee?.createdAt;
        return isValidDate(date) ? date : defaultStartDate;
    });
